import Vue from 'vue'
import firebase from '../../firebase/firebase';
const db = firebase.firestore();

function filterActiveProducts (productType) {
  if (!productType || !productType.products)
    return;
  const products = {};
  Object.entries(productType.products).forEach(([key, value]) => {
    if (value.enabled !== false)
      products[key] = value;
  });
  if (!Object.keys(products).length)
    return;
  productType.products = products;
  return productType;
}

function addSortedProductsList (productType) {
  if (!productType || !productType.products)
    return;
  productType.sortedProducts = Object.entries(productType.products)
    .map(([id, value]) => ({ id, ...value }))
    .sort(defaultOrderFunc);
  return productType;
}

const defaultOrderFunc = (a, b) => {
  return Object.prototype.hasOwnProperty.call(a, 'order') ?
    a.order - b.order :
    (a.description > b.description) - (a.description < b.description);
};

export default {
  namespaced: true,

  state: {
    productTypesByCompany: {},
    menusByCompany: {},
  },

  getters: {
    companyMenus: (state, getters, rootState, rootGetters) => state.menusByCompany[rootGetters.getCompanyID] || [],

    companyProductTypes: (state, getters, rootState, rootGetters) => state.productTypesByCompany[rootGetters.getCompanyID],
    
    sorteredProductTypes: (state, getters) =>
      getters.companyProductTypes && [...getters.companyProductTypes]?.sort(defaultOrderFunc),

    activeProductsOnly: (state, getters) => 
      getters.companyProductTypes && [...getters.companyProductTypes]?.map(p => filterActiveProducts({...p}))
        .filter(pt => pt)
        .sort(defaultOrderFunc),

    productTypesOrderedByMenu: (state, getters,) => {
      const menus = getters.companyMenus;
      if (!menus?.length || !getters.sorteredProductTypes)
        return getters.sorteredProductTypes;
      return [...getters.sorteredProductTypes].sort((a, b) => {
        const menuA = menus.find(m => m.id === a.menu)?.order || -1;
        const menuB = menus.find(m => m.id === b.menu)?.order || -1;
        return menuA - menuB;
      });
    },
  },

  actions: {
    async fetchMenus ({ commit, rootGetters, state }, force) {
      const companyId = rootGetters.getCompanyID;
      if (!force && state.menusByCompany[companyId])
        return;
        
      const menusSnap = await db.collection(`company/${companyId}/menu`)
        .orderBy('order').get();
      const menus = [];
      menusSnap.forEach(m => {
        menus.push( { id: m.id, ...m.data() });
      })
      commit('setMenus', { companyId, menus });
    },

    async fetchProductTypes ({ state, rootGetters, commit }, force) {
      const companyId = rootGetters.getCompanyID;

      if (!force && state.productTypesByCompany[companyId])
        return;

      db.collection(`company/${companyId}/productType`)
        .onSnapshot(snapshot => {
            snapshot.docChanges().forEach(change => {
                const productType = { id: change.doc.id, ...change.doc.data() }
                if(change.type === "added") {
                  commit('addProductTypes', { productType, companyId })
                }
                if(change.type === "modified") {
                    commit('updateProductTypes', { productType, companyId })
                }
                if(change.type === 'removed') {
                  commit('removeProductTypes', { productType, companyId })
                }
            })
        })
    },
  },

  mutations: {
    setEmptyProductType(state) {
      state.productTypes = []
    },

    removeProductTypes (state, { productType, companyId }) {
      state.productTypesByCompany[companyId] = state.productTypesByCompany[companyId].filter(pt => pt.id !== productType.id);
    },

    updateProductTypes (state, { productType, companyId }) {
      state.productTypesByCompany[companyId] = state.productTypesByCompany[companyId].filter(pt => pt.id !== productType.id);
      
      addSortedProductsList(productType);

      state.productTypesByCompany[companyId].push(productType);
    },

    addProductTypes(state, { productType, companyId }) {
      // for all products, by company - to avoid show undesired data
      if (!state.productTypesByCompany[companyId])
        Vue.set(state.productTypesByCompany, companyId, []);
      
      addSortedProductsList(productType);

      if (Object.keys(productType.products)?.length)
        state.productTypesByCompany[companyId].push(productType);
    },
    setMenus (state, { companyId, menus }) {
      Vue.set(state.menusByCompany, companyId, menus);
    }
  }
}